import React from "react";
import profileThumb from "../../../images/Body-Language-in-the-Workplace.jpg";
import SimilarPositions from "./SimilarPositions";
import { styles } from "./style.ts";

const Sidebar = ({ jobs, address, pending }) => (
  <div style={styles.sidebar.container} className="filter_block sidebar_job">
    <div style={styles.sidebar.profileThumb}>
      <img style={styles.sidebar.img} src={profileThumb} alt="profile thumb" />
    </div>
    <div style={styles.sidebar.haveJobBlock}>
      <span>Have a Job?</span>&nbsp;
      <a href="/employers/post-job" className="btn_post">
        Post It
      </a>
    </div>
    <SimilarPositions jobs={jobs} address={address} pending={pending} />
  </div>
);

export default Sidebar;
